import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref, computed } from "vue";
import { useRoute } from "vue-router/composables";
import { getPostback } from "@/api/autostats";
import { usePostbackSingle } from "@/services/TablePage/postbacks";
import SvgAttention from "@/assets/icons/attention-symbol.svg";
import PageLayout from "@/components_v3/layout/PageLayout.vue";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import BaseList from "@/components-UI/list/BaseList.vue";
import PostbackListItems from "@/components_v3/statistics/PostbackListItems.vue";
import SvgCheck from "@/assets/icons/check.svg";
import { useWindowResize } from "@/utils/useWindowSize";


export default /*#__PURE__*/_defineComponent({
  __name: 'PostbackSingle',
  setup(__props) {

const { getCards } = usePostbackSingle();
const route = useRoute();

const postbackID = ref(0);
const postbackData = ref({});
const cards = ref([]);
const { width } = useWindowResize();

onBeforeMount(() => {
    postbackID.value = route.params.id;
    document.title = `Постбэк ${postbackID.value}`;

    getPostbackCard();
});

const isDesktop = computed(() => width.value > 1264);

const leftCards = computed(() => {
    const cardsArray = Object.values(cards.value);
    return cardsArray.filter((card) => card.col === 0 || (isDesktop.value && card.col === 2));
});

const rightCards = computed(() => {
    const cardsArray = Object.values(cards.value);
    return cardsArray.filter((card) => card.col === 1 || (!isDesktop.value && card.col === 2));
});

const getPostbackCard = async () => {
    const response = await getPostback(postbackID.value);
    postbackData.value = response.data;

    const result = getCards(postbackData.value);
    result.subIDs.items = result.subIDs.items.filter(item => item.value !== '' && item.value !== null);
    cards.value = result;
};

return { __sfc: true,getCards, route, postbackID, postbackData, cards, width, isDesktop, leftCards, rightCards, getPostbackCard, SvgAttention, PageLayout, BaseEditableCard, BaseList, PostbackListItems, SvgCheck }
}

})